





























import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import GenericBTable from "@/core/Generics/GenericBTable";
import Annoucement from "@/models/porposal/porposal.model";
import { BTableColumnType } from "@/enums/BTableColumnType";
import AnnoucementService from "@/services/porposal.service";
import { PermissionValue } from "@/enums/PermissionValue";
import { RowTable } from "@/typings/BRowTable";
import BTableColumn from "@/models/base/BTableColumn.model";
import SendedPorposalTableComponent from "@/components/proposal-table-research-centers/table.vue";
import { ProposalState } from "@/enums/ProposalState";
import baseSelect from "@/components/base/baseSelect/baseSelect.vue";
import { ProjectState } from "../../enums/projectState";
import Porposal from "@/models/porposal/porposal.model";
import ProjectByAnnoucementTableComponent from "../../components/projectByAnnouncement/table.vue";
import ProjectByAnnoucementTableHistoryComponent from "../../components/projectByAnnouncement/table-history.vue";

@Component({
  components: {
    SendedPorposalTableComponent,
    ProjectByAnnoucementTableComponent,
    ProjectByAnnoucementTableHistoryComponent
  }
})
export default class ProjectByAnnoucement extends GenericBTable<Porposal> {
  inProgress: ProjectState = ProjectState.InProgress;
  inHold: ProjectState = ProjectState.InHold;
  cancelled: ProjectState = ProjectState.cancelled;
  created() {
    this.permissionValue = PermissionValue.PROYECTOENEJECUCION;
  }
}
